import { render, staticRenderFns } from "./ViewOriginalOrder.vue?vue&type=template&id=1d4a6cfa&scoped=true"
import script from "./ViewOriginalOrder.vue?vue&type=script&lang=js"
export * from "./ViewOriginalOrder.vue?vue&type=script&lang=js"
import style0 from "./ViewOriginalOrder.vue?vue&type=style&index=0&id=1d4a6cfa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4a6cfa",
  null
  
)

export default component.exports